import styled from 'styled-components'

export const Restrict = styled.div`
	width: 100%;
	max-width: ${props => props.restrict === 'sm' ? "600px" : props.restrict === 'md' ? "900px" : props.restrict === 'lg' ? "1360px" : "1600px"};
	margin: 0 auto;
`
